/* jshint esversion: 6 */

import {Assert} from "common/Assert";
import {Event} from "common/Event";

/***********************************************************************
 Watcher for HTML5-LocalStorage changes. In case of data changed, the
 given event will be fired.
 ***********************************************************************/
export function LocalStorageChangeWatcher() {
    "use strict";

    const localStorageTimestamps = new Map();
    let timoutId = -1,
        time = 0,
        changeEventId = null;

    function onCallbackInterval() {

        if (localStorageHasChanged()) {
            Event.trigger(document, changeEventId);
        }

        timoutId = window.setTimeout(onCallbackInterval, time);
    }

    function localStorageHasChanged() {

        const storage = window.localStorage;
        let index,
            changed = false;

        for (index = 0; index < storage.length; index++) {

            const lessonId = storage.key(index);
            if (!storage.hasOwnProperty(lessonId)) {
                continue;
            }

            const lessonData = storage.getItem(lessonId),
                data = parseData( lessonData );

            if (isValidEntry(data) && timeStampHasChanged(lessonId, data)) {
                changed = true;
            }

            refreshTimeStamp(lessonId, data);
        }

        return changed;
    }

    function parseData( data ){

        let parsedData = "";

        try {
            parsedData = JSON.parse(data);
        }
        catch( e ){

        }

        return parsedData;
    }

    function isValidEntry(data) {
        return data && data.timestamp;
    }

    function timeStampHasChanged(id, data) {

        if (!localStorageTimestamps.has(id)) {
            return true;
        }

        const savedTimeStamp = localStorageTimestamps.get(id);
        return savedTimeStamp !== data.timestamp;
    }

    function refreshTimeStamp(id, data) {
        if( data && data.timestamp ){
        localStorageTimestamps.set(id, data.timestamp);
        }
    }

    // revealing public api
    return {

        startTimer: function (checkIntervalTime, eventId) {

            Assert.checkArgumentType(checkIntervalTime, "number");

            if ((timoutId !== -1) || (checkIntervalTime <= 0) || (typeof eventId !== "string")) {
                return false;
            }

            time = checkIntervalTime;
            changeEventId = eventId;
            timoutId = window.setTimeout(onCallbackInterval, 500);

            return true;
        },

        stopTimer: function () {
            clearTimeout(timoutId);
            timoutId = -1;
            time = 0;
            changeEventId = null;
        }
    };
}
